// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('support.supportcases', {
        url: '',
        views: {
            'supportList': {
            templateUrl: 'main/support/supportcases/supportcases.tpl.html',
            controller: 'SupportCasesController as vm'
        }},
        resolve: {
        }
    });
}

// @ngInject
function SupportCasesController() {
}

angular
    .module('support.supportcases', [
        'support.api',
        'supportcases.addvariantdetail',
        'supportcases.changebarcode',
        'supportcases.changebarcodes',
        'supportcases.changevariantdetail',
        'supportcases.changeisgroupsalearticle',
        'supportcases.changeitemgroup',
        'supportcases.createlocation',
        'supportcases.deleteproduct',
        'supportcases.mergeproducts',
        'supportcases.missingreceipts',
        'supportcases.triggertochangelog',
        'supportcases.updateinventorystatus',
        'supportcases.originalbalanceimport'
    ])
    .config(stateConfig)
    .controller('SupportCasesController', SupportCasesController);
